var _defs, _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFactoryDiagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 540,
    viewBox: "0 0 720 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0C1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0E1F1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accent",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0ED09D",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0AA671",
    stopOpacity: 0.95
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 540,
    rx: 22,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 52,
    width: 636,
    height: 436,
    rx: 18,
    stroke: "#1E3A32",
    strokeWidth: 2,
    strokeDasharray: "8 10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0ED09D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 190H260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 190L310 150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 190L310 230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 190H520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 190L570 150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 190L570 230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 330H360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 330L410 290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 330L410 370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 330H600"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0ED09D",
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 190,
    r: 74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 190,
    r: 74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 330,
    r: 74
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#0ED09D",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 190,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 330,
    r: 12
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#accent)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 120,
    width: 80,
    height: 44,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 216,
    width: 80,
    height: 44,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 120,
    width: 80,
    height: 44,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 216,
    width: 80,
    height: 44,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 260,
    width: 80,
    height: 44,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 356,
    width: 80,
    height: 44,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 312,
    width: 80,
    height: 44,
    rx: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#0ED09D",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 160,
    width: 48,
    height: 60,
    rx: 8,
    fill: "#0E1B18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 300,
    width: 48,
    height: 60,
    rx: 8,
    fill: "#0E1B18"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#CFEFE4",
    fontFamily: "'Inter', 'Segoe UI', system-ui",
    fontSize: 15,
    letterSpacing: 0.4
  }, /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 194
  }, "\u0420\u0430\u0441\u0447\u0451\u0442"), /*#__PURE__*/React.createElement("text", {
    x: 198,
    y: 334
  }, "\u0427\u041F\u0423"), /*#__PURE__*/React.createElement("text", {
    x: 312,
    y: 147
  }, "\u0420\u0435\u0437\u043A\u0430"), /*#__PURE__*/React.createElement("text", {
    x: 312,
    y: 243
  }, "\u0421\u0431\u043E\u0440\u043A\u0430"), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 147
  }, "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u044C"), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 243
  }, "\u041F\u043E\u043A\u0440\u0430\u0441\u043A\u0430"), /*#__PURE__*/React.createElement("text", {
    x: 412,
    y: 287
  }, "\u0424\u0438\u043D\u0438\u0448"), /*#__PURE__*/React.createElement("text", {
    x: 412,
    y: 383
  }, "\u041E\u0442\u0433\u0440\u0443\u0437\u043A\u0430"), /*#__PURE__*/React.createElement("text", {
    x: 612,
    y: 339
  }, "\u041C\u043E\u043D\u0442\u0430\u0436"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#0ED09D",
    strokeWidth: 2,
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 190C120 130 210 118 260 148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 190C520 138 440 120 370 150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 330C360 280 300 252 240 268"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#8BD7BF",
    fontFamily: "'Inter', 'Segoe UI', system-ui",
    fontSize: 12,
    letterSpacing: 0.35
  }, /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 126
  }, "\u0418\u043D\u0436\u0438\u043D\u0438\u0440\u0438\u043D\u0433"), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 120
  }, "\u041C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B"), /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 110
  }, "\u0422\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u044F"), /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 118
  }, "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoryDiagram);
export default __webpack_public_path__ + "static/media/factory-diagram.e476c5a86410cab2f478999827985d6e.svg";
export { ForwardRef as ReactComponent };